<template>
<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.57813 3.29095L8.57812 12.4546" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3.99707 7.87277L8.57889 12.4546L13.1607 7.87277" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
